import React from 'react';
import styled from 'styled-components';
import { fonts, colors, links } from '../common/mixins.js';
import Icon from '../common/Icon.jsx';
import ManageYourOrder from './ManageYourOrder.jsx';
import DateLocation from './DateLocation.jsx';
import ReservationOrganizer from './ReservationOrganizer.jsx';
import useMediaQuery from '@mui/material/useMediaQuery';

const StyledInfoContainer = styled.div`  
    display:flex;
    flex-direction:column;
    background-color:white;
    width:100%;
    padding:20px 16px 16px 16px;
    border-radius:8px;
    height:100%;
    `;

const Top = styled.div`
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    gap:24px;
    width:100%;
    padding-bottom:16px;
    border-bottom:1px solid #EDF1F6;
    @media (max-width: 767px) {
        padding-bottom:0;
        border-bottom:none;
    }
    `;

const Title = styled.a`
    ${links.linkBrightPurple()};
    ${props => !props.href && `
      pointer-events: none;
      cursor: default;
      color: #0D0C1C;
    `}
    `;

const Icons = styled.div`
    display:flex;
    gap:8px;
    align-items:center;
    `;

    const CountIcon = styled.div`
    font-size: 14px;
    font-family: 'pf_highway_sans_pro_lightRg';
    display:flex;
    gap: 4px;
    align-items:center;
    line-height:16px;
    `;

const Content = styled.div`
    height:100%;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    min-height:136px;
    gap:12px;
    margin-top:16px;
     @media (max-width: 1000px) {
     min-height:122px;
  }
   
     @media (max-width: 767px) {
     height:auto;
     min-height:auto;
     gap:12px;
     margin-top:8px;
  }
    `;

const FlexContainer = styled.div`
    width:100%;
    display:flex;
    gap:${(props) => `${props.gap}px`};
    align-items:${(props) => `${props.align}`};
    `;

const DarkLink = styled.div`
    ${links.linkSmallDark()}; 
    `;
const Small = styled.div`
    ${fonts.normalTextSmall()}; 
    `;
const Light = styled.div`
    ${fonts.lightGrayTextSmall()};
    flex-shrink: 0;
    `;

const EventInfo = ({ loading, eventInfoProp, showManageMenu, hasTickets, hasProducts, tickets = [], products = [], organiserData, travelBaseUrl, tellerBaseUrl } ) => {
    const isMobile = useMediaQuery('(max-width:767px)');
  
    const online = eventInfoProp.venueName.toLowerCase().includes('online');
    const location = eventInfoProp.isStreaming ||online
        ? `${eventInfoProp.venueName}`
        : `${eventInfoProp.venueName} - ${eventInfoProp.venueAddress}, ${eventInfoProp.venueCity ? eventInfoProp.venueCity : eventInfoProp.venueArea}`;
    const dateLocation = {
        customDate: eventInfoProp.customDate,
        customTime: eventInfoProp.customTime,
        date: eventInfoProp.eventDateTime,
        location: location,
        culture: eventInfoProp.culture,
        mapUrl: eventInfoProp.venueMapUrl,
        venueName: eventInfoProp.venueName,
        isStreaming: eventInfoProp.isStreaming
    };

    return (
        
         <StyledInfoContainer>
             <Top>
                {!loading && (
                    <>
                        <Title
                            href={eventInfoProp.eventUrl}
                            target={!window.location.host.includes('moreapp') ? '_blank' : '_self'}
                        >
                            {eventInfoProp.eventName}
                        </Title>
                        {isMobile ? (
                           showManageMenu && <ManageYourOrder hasTickets={hasTickets} hasProducts={hasProducts} tickets={tickets} products={products} isMobile={isMobile} travelBaseUrl={travelBaseUrl} tellerBaseUrl={tellerBaseUrl} hasReleaseSeat={eventInfoProp.isReleaseSeatAllowed}/>
                        ) : (
                            <Icons>
                                {eventInfoProp.totalTickets > 0 && (
                                    <CountIcon>
                                        <div id="ticketsCount"  style={{color: "#703EFF",height:24,lineHeight:"24px"}}>{eventInfoProp.totalTickets}</div>
                                        <Icon kind={eventInfoProp.totalTickets > 1 ? "tickets" : "ticket_purple"} />
                                    </CountIcon>
                                )}
                                {eventInfoProp.totalProducts > 0 && (
                                    <CountIcon>
                                        <div id="productsCount" style={{color: "#703EFF",height:24,lineHeight:"24px"}}>{eventInfoProp.totalProducts}</div>
                                        <Icon kind="product" />
                                    </CountIcon>
                                )}
                            </Icons>
                        )}
                    </>
                )}
            </Top>
            <Content>
                {!loading && <div>
                    <DateLocation dateLocation={dateLocation} gap={4} margin={4} />
                </div>}
                {!loading &&<div>
                    {!isMobile &&
                        <ReservationOrganizer date={eventInfoProp.reservationDateTime} culture={eventInfoProp.culture} organizer={eventInfoProp.producerName} organiserData={organiserData} />
                    }
                    {isMobile && <Icons>
                        {eventInfoProp.totalTickets>0 && <CountIcon>
                            <div style={{color: "#703EFF"}}>{eventInfoProp.totalTickets}</div>
                            <Icon kind={eventInfoProp.totalTickets > 1 ? "tickets" : "ticket_purple"} />
                        </CountIcon>}
                        {eventInfoProp.totalProducts>0 && <CountIcon>
                            <div style={{color: "#703EFF"}}>{eventInfoProp.totalProducts}</div>
                            <Icon kind='product' />
                        </CountIcon>}
                    </Icons>}
                </div>}
            </Content>
        </StyledInfoContainer >
    );
};

export default EventInfo;